import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import LandmarkLink from 'components/LandmarkLink';
import Button from 'components/Button';
import CenterContent from 'components/CenterContent';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import GlobalModals from '../../shared/modals/globalModals';
import AlertRenderer from '../../shared/alertRenderer';
import useCustomContactLink from '../../shared/useCustomContactLink';
export var HANDLED_ERRORS = ['NOT_TEAM_MANAGER', 'NO_ACCESS_TO_CONTENT', '404', '500'];
function ContactLink(_ref) {
  var children = _ref.children;
  var contactLink = useCustomContactLink();
  return /*#__PURE__*/React.createElement(React.Fragment, null, contactLink.url ? /*#__PURE__*/React.createElement(TextLink, {
    href: contactLink.url,
    target: "_blank"
  }, children) : /*#__PURE__*/React.createElement(TextLink, {
    as: "button",
    onClick: contactLink.openModal
  }, children), /*#__PURE__*/React.createElement(GlobalModals, null));
}
function TranslatedMessage(_ref2) {
  var errorMessage = _ref2.errorMessage;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  if (errorMessage === 'error_content_access_denied') {
    return /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "error_content_access_denied"
    }, "You don\u2019t have permission to view this content. If you think this is an error, please", /*#__PURE__*/React.createElement(ContactLink, null, "let us know"));
  }
  return /*#__PURE__*/React.createElement(Text, null, t(errorMessage));
}
function ErrorScreen(_ref3) {
  var reason = _ref3.reason;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var icon = 'forbidden';
  var errorTitle = 'error_forbidden';
  var errorMessage;
  switch (reason) {
    case 'NOT_TEAM_MANAGER':
      errorMessage = 'error_not_a_team_manager';
      break;
    case 'NO_ACCESS_TO_CONTENT':
      errorMessage = 'error_content_access_denied';
      icon = 'forbidden';
      break;
    case '404':
      errorTitle = 'error_404';
      errorMessage = 'error_content_not_found';
      icon = 'warning';
      break;
    case '500':
      errorTitle = 'error_generic';
      errorMessage = 'error_500';
      break;
    default:
      errorMessage = 'error_not_allowed';
      break;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CenterContent, {
    height: "100%",
    contentWidth: 440
  }, /*#__PURE__*/React.createElement(LandmarkLink, {
    icon: icon,
    title: t(errorTitle),
    button: /*#__PURE__*/React.createElement(Button, {
      as: NavLink,
      to: "/",
      variant: "primary"
    }, t('navbar_home'))
  }, /*#__PURE__*/React.createElement(TranslatedMessage, {
    errorMessage: errorMessage
  }))), /*#__PURE__*/React.createElement(AlertRenderer, null));
}
export default ErrorScreen;